import GithubIcon from "@/assets/svg/github.svg";
import LinkedInIcon from "@/assets/svg/linkedin.svg";
import { NavigationItem } from "@/utils/interfaces";
import { Briefcase, FileText, Mail, User } from "lucide-react";

export const ROUTES = {
  HOME: "/",
  SECRET: "/secret",
  NOT_FOUND: "/404",
  OFFLINE: "/offline",
} as const;

export const NAVIGATION_ITEMS: NavigationItem[] = [
  {
    id: "about",
    label: "About Me",
    icon: <User className="w-5 h-5" />,
    sectionId: "about-section",
  },
  {
    id: "journey",
    label: "My Journey",
    icon: <FileText className="w-5 h-5" />,
    sectionId: "journey-section",
  },
  {
    id: "work",
    label: "Work",
    icon: <Briefcase className="w-5 h-5" />,
    sectionId: "work-section",
  },
  {
    id: "contact",
    label: "Contact",
    icon: <Mail className="w-5 h-5" />,
    sectionId: "contact-section",
  },
];

export const SOCIAL_LINKS = [
  {
    id: "linkedin",
    url: "https://www.linkedin.com/in/dimitar-daskalov-a58594180/",
    icon: LinkedInIcon,
    ariaLabel: "Visit LinkedIn profile",
  },
  {
    id: "github",
    url: "https://github.com/dimitar-daskalov",
    icon: GithubIcon,
    ariaLabel: "Visit GitHub profile",
  },
  {
    id: "email",
    url: "mailto:dimitar.daskalov22@gmail.com",
    icon: Mail,
    ariaLabel: "Send email",
  },
];

export const FULL_PERCENTAGE = 100;

export const MIN_WIDTH = 1024;

export const SAFARI_RENDER_DELAY = 1000;
